import request from '@/axios/index.js'

export function getVoucherDetail(data) {
  return request.axios({
      url: '/user/gold/getVoucherDetail',
      data:data,
      type:"get"
  })
}


// WEBPACK FOOTER //
// ./src/api/mobile.js